import React from "react";
import Hero from "../../Components/Hero/Hero";
import "./Home.css";
// import videoSrc from "../../asset/video3.mp4";
import FAQ from "../../Components/FAQ/Faq";
import { useNavigate } from "react-router-dom";
import { staggerContainer } from "../../utils/motion";
import { motion } from "framer-motion";
import OurServices from "../../Components/Service/Service";
import Package from "../../Components/Package/Package";
import Vendor from "../../Components/Vendor/Vendor";
import AuctionList from "../../Components/AuctionList/AuctionList";

const Home = () => {
  const navigate = useNavigate();

  const handleFaq = () => {
    window.scrollTo(0, 0);
    navigate("/faq");
  };
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      variants={staggerContainer}
      viewport={{ once: false, amount: 0.25 }}
      className="home"
    >
      <Hero />
      <div style={{ marginTop: "45px", marginBottom: "15px" }}>
        <Vendor />
      </div>
      <div>
        <AuctionList />
      </div>
      <OurServices />

      <div>
        <h2
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          FAQ's
        </h2>
        <FAQ
          question="What is BetaHome.ng?"
          answer="BetaHome.ng is a platform that connects customers with funding partners to help them purchase furniture and interior decor from vendors. Customers can repay over 3 to 12 months with an applicable interest rate."
        />
        <FAQ
          question="Is BetaHome.ng Free?"
          answer="Downloading the BetaHome.ng mobile app and creating an account are both completely free. However, you will be required to pay for each good and service that is provided to you over the platform. You have the option to choose anyone who fits your price range and budget from the wide range of product and service providers that are available."
        />
        <FAQ
          question="⁠How does the funding process work?"
          answer={
            <>
              Select your desired betahome.ng Flexpay package furniture/decor or
              from our partner vendors.
              <br />
              Select your desired betahome.ng Flexpay package furniture/decor or
              from our partner vendors.
              <br />
              Apply for financing through BetaHome.ng funding partners.
              <br />
              Get matched with a funding partner.
              <br />
              Repay in flexible installments (3-12 months) with interest.
            </>
          }
        />
        <FAQ
          question="What is the interest rate?"
          answer="Interest rates vary based on the funding partner and repayment duration. You’ll see the applicable rate before confirming your purchase."
        />
        <FAQ
          question="Which vendors are supported?"
          answer="We partner with trusted furniture and interior decor vendors. Browse our app or website to see available options."
        />
        <FAQ
          question="How do I purchase BetaHome.ng products?"
          answer="When you register to buy any of the products offered on the BetaHome.ng platform, you have the option of paying in full up front or using an installment payment plan of your choice."
        />
        <FAQ
          question="How Does It Work?"
          answer={`1. Choose the Product Package You Prefer:\n2. Sign the sales contract\n3. Select a payment plan\n4. Pay in instalments\n5. Select a shipping date.\n6. BetaHome.ng agents deliver the order and assemble it (between 5–10 working days).`}
        />
        <FAQ
          question="How do I make payment for BetaHome.ng Products?"
          answer="Every BetaHome.ng product and service must be paid for using the payment gateway offered and approved on the platform. In the case of an instant cash payment, customers or prospects may only make such payments to a third party (Beta Ambassador) with BetaHome.ng's prior approval and clearance to handle such payment transactions on the company's behalf."
        />

        <button className="faqButton" onClick={handleFaq}>
          See All FAQs
        </button>
      </div>
      <div>
        <img className="visionImage" src="homeBanner.webp" alt="Vision" />
      </div>
    </motion.div>
  );
};

export default Home;
